import React from 'react';
import globals from '../../../config/appconfig'
import styles from './Header.module.css';

class Header extends React.Component {
    render() {
        return (
            <div className={styles.styleHeader}>
                <img className={styles.headerImg} alt="header" src={globals["app-header-image"]}/>
            </div>
        );
    }
}

export default Header;
